export interface NodeData {
  id: string;
  appName?: string;
  category?: string;
  status?: 'connected' | 'partial' | 'notconnected';
  onhover?: boolean;
}

export const butterflyData: NodeData[] = [
  {
    id: 'Deel',
    appName: 'Deel',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'DocuSign',
    appName: 'DocuSign',
    category: 'applications',
    status: 'partial',
    onhover: true,
  },
  {
    id: 'Kantata',
    appName: 'Kantata',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Gitlab',
    appName: 'Gitlab',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Webex',
    appName: 'Webex',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'ServiceNow',
    appName: 'ServiceNow',
    category: 'applications',
    status: 'partial',
    onhover: true,
  },
  {
    id: 'Gsuit',
    appName: 'Gsuit',
    category: 'applications',
    status: 'notconnected',
    onhover: true,
  },
  {
    id: 'Mode',
    appName: 'Mode',
    category: 'applications',
    status: 'partial',
    onhover: true,
  },
  {
    id: 'Netsuite',
    appName: 'Netsuite',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Onelogin',
    appName: 'Onelogin',
    category: 'applications',
    status: 'partial',
    onhover: true,
  },
  {
    id: 'Slack',
    appName: 'Slack',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Salesforce',
    appName: 'Salesforce',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Zoom',
    appName: 'Zoom',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Asana',
    appName: 'Asana',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Trello',
    appName: 'Trello',
    category: 'applications',
    status: 'notconnected',
    onhover: true,
  },
  {
    id: 'Zendesk',
    appName: 'Zendesk',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'HubSpot',
    appName: 'HubSpot',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Jira',
    appName: 'Jira',
    category: 'applications',
    status: 'partial',
  },
  {
    id: 'Dropbox',
    appName: 'Dropbox',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'Notion',
    appName: 'Notion',
    category: 'applications',
    status: 'partial',
  },
  {
    id: 'Confluence',
    appName: 'Confluence',
    category: 'applications',
    status: 'connected',
  },
  {
    id: 'MSOffice365',
    appName: 'MSOffice365',
    category: 'identity',
    status: 'connected',
  },
  {
    id: 'Tenable',
    appName: 'Tenable',
    category: 'identity',
    status: 'partial',
  },
  {
    id: 'Thycotic',
    appName: 'Thycotic',
    category: 'identity',
    status: 'connected',
  },
  {
    id: 'TopSecret',
    appName: 'TopSecret',
    category: 'identity',
    status: 'partial',
  },
  {
    id: 'VevaVault',
    appName: 'VevaVault',
    category: 'vaults',
    status: 'connected',
  },
  {
    id: 'Vault',
    appName: 'Vault',
    category: 'vaults',
    status: 'partial',
  },
  {
    id: 'OneKosmos',
    appName: 'OneKosmos',
    category: 'vaults',
    status: 'connected',
  },
];

export const dummyfun2 = () => {};

// export const butterflyData: NodeData[] = [];

export const dunnmyfun = () => {};

// export const butterflyData: NodeData[] = [
//   {
//     id: 'Gsuit',
//     appName: 'Gsuit',
//     category: 'applications',
//     status: 'notconnected',
//   },
//   {
//     id: 'MSOffice365',
//     appName: 'MSOffice365',
//     category: 'identity',
//     status: 'connected',
//   },
//   {
//     id: 'Vault',
//     appName: 'Vault',
//     category: 'vaults',
//     status: 'partial',
//   },
// ];
